import { call, put } from "redux-saga/effects";
import { createModule } from "saga-slice";
import { loadData } from "./dataService";

const dataSlice = createModule({
    name: "data",
    initialState: {
        puissFis: [],
        categVH:[],
        entretReg:[],
        etatVH:[],
        entrestruc:[],
        puissFisKm:[],
        carburant:[],
        reform:[],
        assurances:[],
        villes:[],
        isFetching: false,
        error: null
        
    },
    reducers: {
        loadData: (state) => {
            state.isFetching = true;
        },
        fetchedData: (state, payload) => {
            state.puissFis = payload.body.puissFis;
            state.categVH = payload.body.categVH;
            state.entretReg = payload.body.entretReg;
            state.etatVH = payload.body.etatVH;
            state.puissFisKm = payload.body.puissFisKm;
            state.carburant = payload.body.carburant;
            state.entrestruc = payload.body.entrestruc;
            state.reform = payload.body.reform;
            state.assurances = payload.body.assurances;
            state.villes = payload.body.villes;
        },
        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state) => {
            state.isFetching = false;
            state.error = "An error occured";
        },
    },
    sagas: (A) => ({
        *[A.loadData]({ payload }) {
            try {
                const { data } = yield loadData();
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
    })
})

export default dataSlice;
export const dataActions = dataSlice.actions;
